import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=1d03c5cc&scoped=true"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d03c5cc",
  null
  
)

export default component.exports